import { StyledActivityTable } from './ActivityTable.style';
import useActivityData, {
  DEFAULT_PAGINATION
} from './useActivityData/useActivityData';
import useTableLayout from './useTableLayout/useTableLayout';
import LoadingTable from '../../../../projects/ResourceAllocationOverview/JiraStats/LoadingTable';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import Table from 'components/base/Table';
import _ from 'lodash';
import Filters from './Filters/Filters';
import EmptyDataPlaceHolder from './EmptyDataPlaceHolder';

const ActivityTable = () => {
  const { data, isLoading, pagination, tableSortBy } = useActivityData();
  const { cols = [], rows = [] } = useTableLayout({ data });

  const isDataExists = _.size(data) > 0;

  return (
    <StyledActivityTable>
      <Filters />
      <main>
        {isLoading ? (
          <LoadingTable cols={cols} rowsNumber={pagination.pageSize} />
        ) : (
          <TableNoLeftRightBorders>
            <Table
              data={rows}
              columns={cols}
              withPagination
              totalRows={pagination.total}
              rowsPerPage={pagination.pageSize}
              rowsPerPageOptions={DEFAULT_PAGINATION.PAGES}
              onChangeRowsPerPage={event =>
                pagination.setPageSize(event.target.value)
              }
              onChangePage={(event, nextPage) =>
                pagination.setPage(nextPage + 1)
              }
              page={!isDataExists ? 0 : pagination.page - 1}
              sortBy={tableSortBy.key}
              sortOrder={tableSortBy.dir}
              onSort={(key, dir) => tableSortBy.onChange({ key, dir })}
              allowEmptyData={true}
              EmptyDataPlaceHolder={EmptyDataPlaceHolder}
            />
          </TableNoLeftRightBorders>
        )}
      </main>
    </StyledActivityTable>
  );
};

export default ActivityTable;
